// @ts-nocheck
import React from 'react';
import { Drawer, DrawerSuspense } from '@/components';
import withDrawers from '@/containers/Drawer/withDrawers';

import { compose } from '@/utils';

const CustomerDepositsDetailDrawerContent = React.lazy(() =>
  import('./CustomerDepositsDetailDrawerContent'),
);

/**
 * customer deposits detail drawer.
 */
function CustomerDepositsDetailDrawer({
  name,
  // #withDrawer
  isOpen,
  payload: { customerDepositsId },
}) {
  return (
    <Drawer
      isOpen={isOpen}
      name={name}
      style={{ minWidth: '700px', maxWidth: '900px' }}
      size={'65%'}
    >
      <DrawerSuspense>
        <CustomerDepositsDetailDrawerContent customerDepositsId={customerDepositsId} />
      </DrawerSuspense>
    </Drawer>
  );
}
export default compose(withDrawers())(CustomerDepositsDetailDrawer);
